// extracted by mini-css-extract-plugin
export default {"forwardcoaching":"fIyvDW6ekru1VKdMRYXS","forwardcoaching_button":"uS7VHQE4r2eilK6qUX9Q","link":"MuyCfDTNZOMnjvJSe8rN"};